/** Centred layout wrapper for authentication pages (login, sign-up, reset). */
import React from 'react';

interface AuthLayoutProps {
  children: React.ReactNode;
}

export default function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div
      className="min-h-dvh flex items-center justify-center px-6 py-12"
      style={{
        background: 'var(--color-bg)',
        color: 'var(--color-text)',
        fontFamily: 'var(--font-sans)',
      }}
    >
      <div className="w-full max-w-sm">{children}</div>
    </div>
  );
}
